import GrowthPotential from "../../../src/visualization/connectedCharts/ConnectedGrowth";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Feasibility — The Atlas of Economic Complexity",
      description:
        "Compare products by complexity and a country's ability to diversify into them.",
      ogImage: "share_feasibility.png",
    },
    args,
  );
}

export default function FeasibilityRoute() {
  return <GrowthPotential />;
}
